import React, {useState} from 'react'
import {Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import AddAdditionalPosition from 'components/popup/addAdditionalPosition/AddAdditionalPosition';
import Tr from 'translations/Translations';
import getObjectValue from 'libs/getObjectValue';
import GridBlock from 'components/GridBlock';
import AddButton from 'components/button/AddButton';
import ConditionElement from './ConditionElement';
import {withRouter} from "react-router";
import {addElementsToParts, removeElementsfromParts} from "../lib/manipulateElementsOnParts";
import ConfirmDeleteCriterion from "./ConfirmDeleteCriterion";
import _ from 'lodash'
const style = theme => ({
    root: {},
    header: {
        marginTop: theme.spacing(1),
        fontWeight: theme.typography.fontWeightBold,
    },
})

function AdditionalPositionsSection(
    {
        classes,
        formikProps,
        id,
        partId,
        stageId,
        match,
    }) {
    const [openPopup, setOpenPopup] = useState(false)
    const [editElement, setEditElement] = useState();
    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const demandId = match.params.id;

    const thisId = id;

    const elements = getObjectValue(thisId, formikProps.values, [])
    const editable = getObjectValue('_editable', formikProps.values, true);

    const handleAddPosition = ({parts, ...values}) => {
        addElementsToParts(formikProps, thisId, parts, values, editElement, demandId);
        setOpenPopup(false)
        setEditElement()
    }

    // eslint-disable-next-line
    const handleEdit = (index) => {
        setEditElement(_.cloneDeep(elements[index]));
        setOpenPopup(true);
    }

    const handleDeleteButtonPress = (index) => {
        setEditElement(_.cloneDeep(elements[index]));
        setOpenDeletePopup(true);
    }

    const onCloseDeletePopup = () => {
        setOpenDeletePopup(false)
        setEditElement();
    }

    const handleDeleteCondition = ({parts}) => {
        removeElementsfromParts(formikProps, id, parts, editElement, demandId);
        setOpenDeletePopup(false);
        setEditElement();
    }

    return (
        <>
            <GridBlock
                className={classes.root}
                column
            >
                <Typography
                    variant='body1'
                    className={classes.header}
                >
                    {Tr('additional_positions')}({elements.length})
                </Typography>
                <GridBlock alignItems='center'>
                    {elements.map((item, i) => {
                        return (
                            <ConditionElement
                                id={thisId}
                                index={i}
                                formikProps={formikProps}
                                name={item.name}
                                key={i}
                                onEdit={() => handleEdit(i)}
                                onDelete={handleDeleteButtonPress}
                                disabled={!editable}
                            />
                        )
                    })}

                    <AddButton
                        onClick={() => {
                            setEditElement()
                            setOpenPopup(true)
                        }}
                        disabled={!editable}
                    >
                        {Tr('additional_form_items')}
                    </AddButton>
                </GridBlock>
            </GridBlock>

            {openPopup && <AddAdditionalPosition
                onAdd={handleAddPosition}
                onClose={() => setOpenPopup(false)}
                initValues={editElement}
                partId={partId}
                elementList={formikProps.values.form}
                showParts={editable}
            />}
            {openDeletePopup && <ConfirmDeleteCriterion
                onClose={() => onCloseDeletePopup()}
                onDelete={handleDeleteCondition}
                partId={partId}
                demandId={demandId}
                stageId={stageId}
                initCrit={editElement}
                allItems={formikProps.values.form}
                id={id}
            />}
        </>
    )
}

AdditionalPositionsSection.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(withRouter(AdditionalPositionsSection));